import * as Rt from 'runtypes';

export const Integer = Rt.Number.withConstraint((n) => Number.isInteger(n));
export const PosInt = Integer.withConstraint(n => n >= 0);
